import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import AdminMenu from "../../AdminMenu";

import {
  Bar,
  Line,
  Pie,
  Doughnut,
  Radar,
  PolarArea,
  Scatter,
  Bubble,
} from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  RadarController,
  Tooltip,
  Title,
  Legend,
  RadialLinearScale,
} from "chart.js";
import { formatDate, localeDateEndDate, localeDateStartDate } from "../../../constants/DateUtil/DateUtil";
import SchedularModal from "../../SchedularModal";
import { ProgressSpinner } from "primereact/progressspinner";
import { topSaleService } from "../../../services/TopSale/TopSaleServices";

// Register components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  RadarController,
  Tooltip,
  Title,
  Legend,
  RadialLinearScale
);

const OverallRevenue = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {}; // Fallback to prevent undefined errors

  const [topGarmentServiceData, setTopGarmentServiceData] = useState([]);
  const [modalMenuVisible, setModalMenuVisible] = useState(false);

  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const { userProfileRole, brandProfileData } = getUserData();
  const userRole = userProfileRole;
  const brandOfferModal = brandProfileData.brandOffModel;
  const brandId = brandProfileData.id;
  const fetchDataSale = (data) => {
    setLoading(true);
    topSaleService(data)
      .then((response) => {
        if (!response.data.error) {
          const reportMapsArray = response.data.reduce(
            (accumulator, currentItem) => {
              // Iterate through each reportMap entry and add service name
              const reportMapWithService = Object.entries(
                currentItem.reportMap
              ).map(([key, value]) => ({
                ...value,
                Service: currentItem.name,
              }));

              setLoading(false);
              // Concatenate the reportMap objects with service name to the accumulator
              return accumulator.concat(reportMapWithService);
            },
            []
          );

          setTopGarmentServiceData(reportMapsArray);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    const dataSale = {
      brandIds: [brandId],
      startDate:
        brandProfileData.createdDate !== null
          ? localeDateStartDate(new Date(brandProfileData.createdDate))
          : "2024-01-01T00:00:00Z",
      endDate: localeDateEndDate(new Date(new Date())),
      sortBy: "sale",
      statusIn: [
        "BOOKED",
        "INPROCESS",
        "PROCESSED",
        "IN_WAREHOUSE",
        "DELIVERED",
        "DONE",
        // "CANCEL",
        // "UNPROCESSED",
        "OUT_FOR_DELIVERY",
        "DELAY",
      ],
    };
    fetchDataSale(dataSale);
  }, []);

  const renderAdminCardItem = () => {
    return topGarmentServiceData.map((item) => (
      <div className="flex-1 flex flex-row mx-2  ">
        <div style={{ flex: 2 }}>
          <p className=" text-lg font-medium">
            {item.saleKey.replace(/_/g, " ")}
          </p>
        </div>
        <div className="flex-1">
          <p className=" text-lg font-medium">
            {item.Service.replace(/_/g, " ")}
          </p>
        </div>
        <div className="flex-1">
          <p className="text-lg font-medium text-right">{item.quantity}</p>
        </div>
        <div className="flex-1">
          <p className="text-lg font-medium text-right">{item.sales}</p>
        </div>
      </div>
    ));
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/AnalyticsList")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Overall Summary
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div>
        <div className="flex-1  surface-0" style={{ "--surface-0": "#EAEFF5" }}>
          <div className="flex justify-content-between mx-4">
            <div className="py-1">
              <p className=" text-2xl  font-bold ">SUMMARY</p>
            </div>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="flex flex-1 flex-column justify-content-center align-items-center">
          <ProgressSpinner />
          <p className="text-3xl font-bold">Loading Summary Data...</p>
        </div>
      ) : topGarmentServiceData.length > 0 ? (
        <div>
          <div className="mx-4 my-3">
            <div className="flex flex-row py-1 mx-2 justify-content-between">
              <p className="text-2xl font-bold " style={{ flex: 2 }}>
                Name
              </p>
              <p className="flex-1 text-2xl font-bold ">Service</p>
              <p className="flex-1 text-2xl font-bold text-right">Quantity</p>
              <p className="flex-1 text-2xl font-bold text-right">Sale</p>
            </div>
            {renderAdminCardItem()}
          </div>
        </div>
      ) : (
        <div className="flex flex-1 justify-content-center align-items-center">
          <p className="text-3xl font-bold">No Summary Found</p>
        </div>
      )}

      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default OverallRevenue;
